import * as Yup from 'yup';
import { Button, Grid, Box, Stack, Typography } from '@mui/material';
import { Icons } from '../../assets/icons';
import { FormInput } from '../../components/hook-form/form-input.component';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { LoginInfo, LoginResponse } from '../../models/login-info';
import { loginApiKeyStore } from '../../api/login-api-key-store';
import { ApiErrorComponent } from '../../components/api-error.component';
import { useSaveData, useSaveDataForPostInDux } from '../../hooks/useSaveData';
import { truncate } from 'fs';
import { useStorage } from '../../hooks/use-storage';
import { StorageKey } from '../../constants';

interface LoginPageProps {
  onLoginSuccess: (token: string, refreshToken: string) => any;
  isLoadingUser?: boolean;
}
const signinValidationSchema = Yup.object().shape({
  username: Yup.string().required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const styling = {
  textStyle: { cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' },
  textColor: { color: '#0000b5' }
};

export const LoginPage = ({ onLoginSuccess, isLoadingUser }: LoginPageProps) => {
  const form = useReactHookForm({
    values: {
      username: '',
      password: '',
    },
    yupSchema: signinValidationSchema,
  });
  const [authToken, setAuthToken] = useStorage<string | undefined>(StorageKey.REFRESH_TOKEN, undefined);
  const { isLoading, isError, mutateAsync, error } = useSaveData<LoginResponse>(loginApiKeyStore.login(), undefined);

  const handleSubmit = async (credentials: LoginInfo) => {
    const result = await mutateAsync({ data: credentials });

    if (result.data.accessToken) {
      onLoginSuccess(result.data.accessToken, result.data.refreshToken);
      setAuthToken(result.data.refreshToken);
    }
  };

  const handleForgotPassword = () => {
    window.location.href = '/forgot-password';
  };

  const isUATProductionEnable = process.env.REACT_APP_UAT_PRODUCTION === 'false';

  return (
    <ReactHookForm
      formName="LOGIN_FORM"
      onSubmit={handleSubmit}
      formContextProps={form}
      isBusy={isLoading || isLoadingUser}
    >
      <Grid container className="loginform" justifyContent="center" alignItems="center">
        <Grid item xs={4} className="loginWrap">
          <Stack className="brandName">
            <img src={Icons.Logo} alt="SI Track" />
          </Stack>
          {isUATProductionEnable && (
            <Box justifyItems='center' alignItems='center'>
              <Typography variant='body1' style={styling.textColor}>UAT Version</Typography>
            </Box>
          )}
          <Box>
            <FormInput label="Username" name="username" maxLength={250} autoFocus isShrink={true} />
          </Box>
          <Box>
            <FormInput label="Password" name="password" type="password" maxLength={100} isShrink={true} />
          </Box>
          <Box>
            <ApiErrorComponent isError={isError} errorRespnse={error} />
          </Box>
          <Box>
            <Button type="submit" variant="contained" disableElevation size="medium" fullWidth>
              Login
            </Button>
          </Box>
          <Box>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
              }}
            >
              <div onClick={handleForgotPassword} className="flex-end">
                <Typography variant="body2" style={styling.textStyle}>
                  Forgot Password?
                </Typography>
              </div>
            </Grid>
          </Box>
          <Typography variant="body2" className="loginfooter">
            © {new Date().getFullYear()} Specialty Inspectors, LLC. All Right Reserved.
          </Typography>
        </Grid>
      </Grid>
    </ReactHookForm>
  );
};
